import React from 'react';
import gql from 'graphql-tag';
import { InputDlg } from './input-dialog';
import { Form as FForm, Formik } from 'formik';
import {
  ButtonSearch,
  FieldInput,
  FieldSelectYesNo,
  FormCol9,
  FormRow,
  TableCellV8,
  FilterProps,
  promiseModalSelect,
} from 'motion-components';
import { Form, Col } from 'react-bootstrap';
import { useRootStore } from 'store';

const FormCol19 = (props) => (
  <Col sm={12} lg={9} xl={9} {...props}>
    {props.children}
  </Col>
);
/* ----------------------------------
   Select Vehicle with Modal Search
   ---------------------------------- */
type Props = {
  initValueId: string;
  initValueName: string;
  onValueChange: (valueId: string, valueName: string) => void;
  required?: boolean;
  initFilters?: any;
};

export const FieldVehicleDlg = ({
  initValueId = undefined,
  initValueName = '',
  onValueChange,
  required = false,
  initFilters = {},
}: Props) => {
  const { appStore } = useRootStore();
  const valueChanged = (valueId, valueName) => {
    onValueChange(valueId, valueName);
  };

  return (
    <InputDlg
      valueId={initValueId}
      valueName={initValueName}
      onDlgClick={async (event) => {
        const res = await promiseModalSelectVehicle({ initFilters, appStore });
        return { newId: res?.guid, newName: res?.plateNo };
      }}
      onValueChange={valueChanged}
    />
  );
};

// -------------------------------------------------------------------------------
// Modal Select Vehicle
// -------------------------------------------------------------------------------

const gqlGetList = gql`
  query getVehicles($where: String, $offset: Int, $limit: Int, $order: String) {
    getVehicles(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        guid
        plateNo
        owner {
          guid
          name
        }
        truckType
        isNotActive
      }
      recordCount
    }
  }
`;

const columns = [
  {
    id: 'plateNo',
    header: 'Πινακίδα',
    columnName: 'Πινακίδα',
    accessorKey: 'plateNo',
    orderByField: 'plateNo',
    cell: TableCellV8,
    size: 120,
  },
  {
    id: 'owner',
    header: 'Ιδιοκτησία',
    columnName: 'Ιδιοκτησία',
    accessorKey: 'owner.name',
    orderByField: 'owner.name',
    cell: TableCellV8,
    size: 120,
  },
];

// -------------------------------------------------------------------------------
// Filters
// -------------------------------------------------------------------------------
const buildWhereFromFilters = (values) => {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText)
      where = {
        ...where,
        ...{
          plateNo: { $like: '%' + values.searchText + '%' },
        },
      };
    if (values.useInDeliveries !== undefined) {
      where = { ...where, useInDeliveries: values.useInDeliveries };
    }
    if (values.useInDispatches !== undefined) {
      where = { ...where, useInDispatches: values.useInDispatches };
    }
    if (values.useInProduction !== undefined) {
      where = { ...where, useInProduction: values.useInProduction };
    }
  }
  return where;
};

const VehFilters: (props: FilterProps) => JSX.Element = ({ onChange, initialValues }) => {
  return (
    <Formik initialValues={initialValues ? initialValues : { searchText: '' }} onSubmit={onChange}>
      <Form as={FForm}>
        <FormRow className="mb-3 align-items-end">
          <FieldInput
            as={FormCol9}
            name="searchText"
            id="searchText"
            label="Πινακίδα"
            type="search"
          />
          <Col className="ps-0 pe-0 me-3 ">
            <ButtonSearch size="sm" type="submit" className="float-end mb-2" />
          </Col>
        </FormRow>
        <FormRow className="align-items-end">
          <FieldSelectYesNo as={Col} name="useInDeliveries" label="Χρήση σε Παραλαβές" />
          <FieldSelectYesNo as={Col} name="useInDispatches" label="Χρήση σε Αποστολές" />
          <FieldSelectYesNo as={Col} name="useInProduction" label="Χρήση σε Παραγωγές" />
        </FormRow>
      </Form>
    </Formik>
  );
};

// -------------------------------------------------------------------------------
export const promiseModalSelectVehicle = (props) => {
  return promiseModalSelect({
    ...props,
    title: 'Επιλογή Οχήματος',
    columns,
    gqlQuery: gqlGetList,
    orderBy: 'plateNo',
    buildWhereFromFilters: buildWhereFromFilters,
    initFilters: props.initFilters,
    Filters: VehFilters,
  });
};
// -------------------------------------------------------------------------------

